import { useState, useEffect } from 'react';

const getOrientation = () =>
  window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';

export const useOrientation = () => {
  const [orientation, setOrientation] = useState(getOrientation());

  useEffect(() => {
    const mediaQuery = window.matchMedia('(orientation: portrait)');
    const handleChange = () => setOrientation(getOrientation());

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return orientation;
};
